import Avatar from '@mui/material/Avatar';
import { generateTestId } from '@vs/functions/generate-test-id';
import { PortalLink } from '@vs/ui/portal/link';

export interface PortalAvatarUserProfileCardProps {
  title: string;
  textMain: string;
  textSub?: string | null;
  logoUrl?: string;
  link?: {
    href: string;
    label: string;
  };
  testIdName?: string;
}

export function PortalAvatarUserProfileCard({
  textMain,
  textSub,
  logoUrl,
  link,
  title,
  testIdName,
}: PortalAvatarUserProfileCardProps) {
  return (
    <div className="px-6 pt-4" {...generateTestId('block', [testIdName])}>
      <div className="vs-body-xs-regular text-vs-base-content-variant leading-5">
        {title}
      </div>
      <div className="flex items-center space-x-4 min-h-[80px]">
        <div className="flex-shrink-0 w-[56px] h-[56px]">
          <Avatar
            sx={{ width: 56, height: 56 }}
            alt={textMain}
            src={logoUrl}
            className="cursor-pointer"
          />
        </div>
        <div className="flex flex-col gap-1">
          <div className="vs-heading-xs-bold leading-7">{textMain}</div>
          {textSub && (
            <div className="vs-body-xs-regular leading-5">{textSub}</div>
          )}
          {link && (
            <div className="leading-3">
              <PortalLink
                {...generateTestId('link', [testIdName])}
                variant="secondary"
                className="vs-body-xs-regular"
                href={link?.href}
                target="_blank"
              >
                {link?.label}
              </PortalLink>
            </div>
          )}
        </div>
      </div>
      <div className="border-vs-neut-300 border-b w-full mt-4" />
    </div>
  );
}

export default PortalAvatarUserProfileCard;
